export const geetestValCodeMixin = {
  data() {
    return {
      isgt: false,
      geetestPendingTelephone: "",
      geetestPendingSceneKey: ""
    };
  },
  methods: {
    // 触发极验，并记录本次要发送验证码的手机号与场景标识（用于支持同页多个倒计时）
    requestValCodeV2(telephone, sceneKey) {
      this.geetestPendingTelephone = telephone;
      this.geetestPendingSceneKey = sceneKey || "default";
      if (this.isgt) {
        this.isgt = false;
        this.$nextTick(() => {
          this.isgt = true;
        });
      } else {
        this.isgt = true;
      }
    },
    // 极验组件内部状态变化时同步父组件开关
    onGeetChange(val) {
      this.isgt = val;
    },
    // 极验通过后，调用后端合并接口 val_code_v2 发送短信验证码
    onGeetestValCodePath(val) {
      let telephone = this.geetestPendingTelephone;
      let sceneKey = this.geetestPendingSceneKey;
      this.isgt = false;

      this.$post(
        `/common/platform/val_code_v2?telephone=${encodeURIComponent(
          telephone
        )}&challenge=${encodeURIComponent(
          val.geetest_challenge
        )}&validate=${encodeURIComponent(val.geetest_validate)}&seccode=${encodeURIComponent(
          val.geetest_seccode
        )}`
      ).then(res => {
        if (res.code == 0) {
          this.$message({
            message: res.message,
            type: "success"
          });
          if (typeof this.onValCodeSent === "function") {
            this.onValCodeSent(sceneKey);
          }
        } else {
          this.$message(res.message || "发送失败");
        }
        this.geetestPendingTelephone = "";
        this.geetestPendingSceneKey = "";
      });
    }
  }
};
